export enum LayoutAnimationEasing {
  Linear = 'Linear',
  QuadraticInOut = 'QuadraticInOut',
  QuadraticIn = 'QuadraticIn',
  QuadraticOut = 'QuadraticOut',
  CubicInOut = 'CubicInOut',
  CubicIn = 'CubicIn',
  CubicOut = 'CubicOut',
  QuarticInOut = 'QuarticInOut',
  QuarticIn = 'QuarticIn',
  QuarticOut = 'QuarticOut',
  QuinticInOut = 'QuinticInOut',
  QuinticIn = 'QuinticIn',
  QuinticOut = 'QuinticOut',
  SinusoidalInOut = 'SinusoidalInOut',
  SinusoidalIn = 'SinusoidalIn',
  SinusoidalOut = 'SinusoidalOut',
  ExponentialInOut = 'ExponentialInOut',
  ExponentialIn = 'ExponentialIn',
  ExponentialOut = 'ExponentialOut',
  CircularInOut = 'CircularInOut',
  CircularIn = 'CircularIn',
  CircularOut = 'CircularOut',
  ElasticInOut = 'ElasticInOut',
  ElasticIn = 'ElasticIn',
  ElasticOut = 'ElasticOut',
  BackInOut = 'BackInOut',
  BackIn = 'BackIn',
  BackOut = 'BackOut',
  BounceInOut = 'BounceInOut',
  BounceIn = 'BounceIn',
  BounceOut = 'BounceOut',
}

export interface LayoutAnimationTarget {
  x?: number;
  y?: number;
  width?: number;
  height?: number;
  angle?: number;
  alpha?: number;
  anchor?: { x?: number; y?: number };
  pivot?: { x?: number; y?: number };
  scale?: { x?: number; y?: number };
  textureName?: string;
}

export interface LayoutAnimationBlockCommon {
  id: string;
  name: string;
  track: number;
  startAt: number;
  sourceName: string;
  target: LayoutAnimationTarget;
}

export interface LayoutAnimationSetterBlock extends LayoutAnimationBlockCommon {
  type: 'Setter';
}

export interface LayoutAnimationTweenBlock extends LayoutAnimationBlockCommon {
  type: 'Tween';
  duration: number;
  easing: LayoutAnimationEasing;
}

export interface LayoutAnimationData {
  id: string;
  name: string;
  playingSpeed: number;
  totalDuration: number;
  blocks: (LayoutAnimationTweenBlock | LayoutAnimationSetterBlock)[];
}

export interface LayoutRawDataWithAnimation {
  animations: LayoutAnimationData[];
}
